/**
 * UM Messages tab entry point.
 *
 * TEMP: reuses CDI/ARC+ Messages UI + endpoints.
 * Replace this implementation when UM messaging has its own API/UI.
 * Navigation stays under /um/messages via module-nav helpers.
 */
import MessageTable from "../../Tables/MessageTable";

const UmMessages = MessageTable;

export default UmMessages;
